import * as ActionType from "../actionType";
import { getCategoriesApi } from "../../services/product/categories";

const getCategoriesAction = () => {
  return async dispatch => {
    dispatchCategories(dispatch);
  };
};

const dispatchCategories = dispatch => {
  dispatch({ type: ActionType.FETCHING_CATEGORIES });
  getCategoriesApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_CATEGORIES,
      data
    });
  });
};

export { getCategoriesAction, dispatchCategories };



// WEBPACK FOOTER //
// ./src/actions/product/categories.js